export enum TrackConstants {
  Notification = 1,
  SiteAssigned = 2,
  Collect = 3,
  Receipt = 4,
  Laboratory = 5,
  Mro = 6,
  RequiresFurtherTesting = 7,
}
